import AttachmentGroupCreateModal from '@UI/modals/AttachmentGroupCreateModal';
import ExtraFieldsModal from '@UI/modals/ExtraFieldsModal';
import GlobalDocumentInsertModal from '@UI/modals/GlobalDocumentInsertModal';
import { GoalSetItemModal } from '@UI/modals/GoalSetItemModal';
import ItemReferenceInsertModal from '@UI/modals/ItemReferenceInsertModal';
import ModalErrorBoundary from '@UI/modals/ModalErrorBoundary';
import { Modal } from '@kathondvla/react-shared-components/src/components';
import { closeExtraFieldsModal } from '@newStore/documentUI/documentUIState';
import type React from 'react';
import { useDispatch } from 'react-redux';
import { useTypedSelector } from '../../../hooks/useTypedSelector';
import { TeaserModal } from '@UI/modals/TeaserModal';

const Modals: React.FC = () => {
  const dispatch = useDispatch();
  const isExtraFieldsModalOpen = useTypedSelector((state) => state.documentUI.extraFieldsModalOpen);
  const isAttachmentGroupModalOpen = useTypedSelector(
    (state) => state.documentUI.attachmentGroupModalData.open,
  );
  const isAddGlobalDocumentModalOpen = useTypedSelector(
    (state) => state.documentUI.addGlobalDocumentModalData.open,
  );
  const isAddItemReferenceModalOpen = useTypedSelector(
    (state) => state.documentUI.addItemReferenceModalData.open,
  );
  const isTeaserModalOpen = useTypedSelector((state) => state.documentUI.teaserModal.open);
  const isGoalSetItemModalOpen = useTypedSelector(
    (state) => state.documentUI.goalSetItemModal.open,
  );

  return (
    <>
      <Modal
        size="md"
        component={<ExtraFieldsModal />}
        errorBoundaryComponent={ModalErrorBoundary}
        open={isExtraFieldsModalOpen}
        onConfirm={() => {
          dispatch(closeExtraFieldsModal());
        }}
        onClose={() => dispatch(closeExtraFieldsModal())}
      />

      <Modal
        size="md"
        component={<AttachmentGroupCreateModal />}
        errorBoundaryComponent={ModalErrorBoundary}
        open={isAttachmentGroupModalOpen}
      />

      <Modal
        size="md"
        component={<GlobalDocumentInsertModal modalTitle={'Toevoegen gedeeld document'} />}
        errorBoundaryComponent={ModalErrorBoundary}
        open={isAddGlobalDocumentModalOpen}
      />

      <Modal
        size="md"
        component={<ItemReferenceInsertModal />}
        errorBoundaryComponent={ModalErrorBoundary}
        open={isAddItemReferenceModalOpen}
      />

      <Modal
        size="md"
        component={<TeaserModal />}
        errorBoundaryComponent={ModalErrorBoundary}
        open={isTeaserModalOpen}
      />

      <Modal
        size="md"
        component={<GoalSetItemModal />}
        errorBoundaryComponent={ModalErrorBoundary}
        open={isGoalSetItemModalOpen}
      />
    </>
  );
};

export default Modals;
